import { create } from 'zustand';
import { EVENT_TYPE } from "../domain";
import { LOCATION_NAME_TO_ID } from "../utils/constants";
import {datetimeLocalToEpoch} from "../utils/formatting";

const useEventStore = create((set, get) => ({
    selectedEvent: {
        user_id: '',
        event_type: EVENT_TYPE.NONE,
        event_timestamp: Date.now(),
        insert_timestamp: Date.now(),
        notes: '',
        created_by: '',
        location_id: LOCATION_NAME_TO_ID.UNSELECTED
    },
    setSelectedEvent: (eventOrFn) => set((state) => ({
        selectedEvent: typeof eventOrFn === 'function' ? eventOrFn(state.selectedEvent) : eventOrFn,
    })),

    updateSelectedEventLocationId: (event) => {
        const currentEvent = get().selectedEvent;
        const location_id = parseInt(event.target.value, 10);
        set({ selectedEvent: { ...currentEvent, location_id } });
    },

    updateSelectedEventTimestamp: (event) => {
        const currentEvent = get().selectedEvent;
        const event_timestamp = datetimeLocalToEpoch(event.target.value);
        set({ selectedEvent: { ...currentEvent, event_timestamp } });
    },

    updateSelectedEventEndTimestamp: (event) => {
        const currentEvent = get().selectedEvent;
        const event_end_timestamp = datetimeLocalToEpoch(event.target.value);
        set({ selectedEvent: { ...currentEvent, event_end_timestamp } });
    },


    clearSelectedEvent: (fieldsToSave = []) => {
        const currentEvent = get().selectedEvent;

        const defaultEvent = {
            user_id: '',
            event_type: EVENT_TYPE.NONE,
            event_timestamp: Date.now(),
            insert_timestamp: Date.now(),
            notes: '',
            created_by: '',
            location_id: LOCATION_NAME_TO_ID.UNSELECTED
        };

        const newEvent = {};

        for (const key in defaultEvent) {
            newEvent[key] = fieldsToSave.includes(key)
                ? currentEvent[key]
                : defaultEvent[key];
        }

        set({ selectedEvent: newEvent });
    }
}));

export default useEventStore;
